//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "read-aggrement",
  data(){
    return{
      aggrement:{}
    }
  },
  methods:{
    back(){
      this.$emit('next',0);
    },
    next(){
      this.$emit('next',2);
    },
  //   获取协议内容
    getAggrement(){
      // this.$loadingShow();
      this.$get('api/before-login/get-article-by-place?_allow_anonymous=true',{showPlace:'REGIST'}).then((data) => {
        if(data){
          this.aggrement = data[0];
        }
      })
    },
  },
  mounted(){
    this.getAggrement();
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier/register/read-aggrement.vue